import { extendObservable, action } from 'mobx';

import { get, jsonParser } from '../utils/Client';

import SelecaoStore from './SelecaoStore';

class MapaStore {
  constructor() {
    extendObservable(this, {
      candidatos: [],

      candidato: null,

      intencoes: [],

      vencedores: [],

      presenca: [],

      loadIntencoesGeralMunicipio: action(() =>
        get(
          `/rodadas/${SelecaoStore.rodadaSelecionada.id}` +
            `/intencoes/geral/municipio/${this.candidato.id}`
        )
          .then(jsonParser)
          .then(data => (this.intencoes = data))
      ),

      loadVencedores: action(tipo =>
        get(
          `/rodadas/${SelecaoStore.rodadaSelecionada.id}` +
            `/${tipo}/vencedores`
        )
          .then(jsonParser)
          .then(data => (this.vencedores = data))
      ),

      loadPresenca: action(tipo =>
        get(
          `/rodadas/${SelecaoStore.rodadaSelecionada.id}` +
            `/${tipo}/presenca/${this.candidato.id}`
        )
          .then(jsonParser)
          .then(data => (this.presenca = data))
      ),

      loadIntencoes: action((tipo, codigo) =>
        get(
          `/rodadas/${SelecaoStore.rodadaSelecionada.id}` +
            `/${tipo}/intencoes/${codigo}`
        )
          .then(jsonParser)
          .then(data => (this.intencoes = data))
      ),
    });
  }
}

export default new MapaStore();



// WEBPACK FOOTER //
// ./src/stores/MapaStore.js